import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { ImBlocked, ImLock, ImUnlocked } from 'react-icons/im';
import Filter from '../../components/filter/filter'
import { api } from '../../components/api/api';
import { Alert, Pergunta, AlertErro } from '../../util/Alertas';
import ButtonTooltip from '../../components/Inputs/ButtonTooltip';

class BloquearClientesModal extends Component {
    constructor(props) {
        super(props);
        this.state = this.initialState;
        this.show = () => this.setState({ show: true });
    }

    initialState = {
        show: false,
        clientes: [],
        filtroNome: '',
    }

    handleCloseModal = () => this.setState(this.initialState)

    render() {
        const { show, clientes, filtroNome } = this.state;

        const fetchClientes = () => {
            api.get(`api/Cliente/BuscarClientes?q=${filtroNome || ""}`, res => {
                this.setState({ clientes: res.data });
            }, error => {
                AlertErro(error, 'Erro ao buscar clientes.');
            })
        }

        const BloquearCliente = async (clientId, nome) => {
            if (await Pergunta("Deseja realmente bloquear o " + nome)) {
                api.post(`/BloqueioPedido/Bloquear/${clientId}`, {}, res => {
                    fetchClientes();
                    this.props.reload && this.props.reload();
                    Alert(`${nome} bloqueado com sucesso!`);
                }, err => {
                    AlertErro(err, `Erro ao bloquear/desbloquear o cliente ${nome}`);
                })
            }
        }

        const Desbloquear = async (clientId, nome) => {
            if (await Pergunta("Deseja realmente desbloquear o " + nome)) {
                api.post(`/BloqueioPedido/Desbloquear/${clientId}`, {}, res => {
                    fetchClientes();
                    Alert(`${nome} desbloqueado com sucesso!`);
                }, err => {
                    AlertErro(err, `Erro ao bloquear/desbloquear o cliente ${nome}`);
                })
            }
        }


        const FormataData = (data) => data ? new Date(data).toLocaleDateString() : '-';

        return (
            <Modal show={show} fullscreen>
                <Modal.Header>
                    Bloquear Cliente
                </Modal.Header>
                <Modal.Body>
                    <Filter
                        filtroNome={filtroNome}
                        handleInputChange={e => { this.setState({ filtroNome: e.target.value }); fetchClientes() }}
                        fetchClientes={fetchClientes}
                    />
                    <table className="table table-striped">
                        <thead>
                            <tr>
                                <th>Id</th>
                                <th>Nome Cliente</th>
                                <th>Bloqueado</th>
                                <th>Data Bloqueio</th>
                                <th>Desbloqueio</th>
                                <th>Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            {clientes.map((cliente, i) => (
                                <tr key={i} className='anexos_pedido'>
                                    <td>{cliente.id}</td>
                                    <td>{cliente.nome}</td>
                                    <td>{cliente.bloqueadoAtraso ? "Sim" : "Não"}</td>
                                    <td>{FormataData(cliente.dataBloqueadoAtraso)}</td>
                                    <td>{FormataData(cliente.dataDesBloqueadoAtraso)}</td>
                                    <td>
                                        {!cliente.bloqueadoAtraso &&
                                            <ButtonTooltip
                                                text={"Bloquear Cliente"}
                                                textButton={<ImLock />}
                                                className={`btn btn-danger`}
                                                top={true}
                                                onClick={() => BloquearCliente(cliente.id, cliente.nome)}
                                            />}
                                        {cliente.bloqueadoAtraso &&
                                            <ButtonTooltip
                                                text={"Desbloquear Cliente"}
                                                textButton={<ImUnlocked />}
                                                className={`btn btn-success`}
                                                top={true}
                                                onClick={() => { Desbloquear(cliente.id, cliente.nome) }}
                                            />}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </Modal.Body>
                <Modal.Footer>
                    {<button onClick={this.handleCloseModal} className='btn btn-success'>Voltar</button>}
                </Modal.Footer>
            </Modal >
        );
    }
}

export default BloquearClientesModal;